import "./styles/global.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Products from "./components/Products";
import Solutions from "./components/Solutions";
import Science from "./components/Science";
import Crops from "./components/Crops";
import Testimonials from "./components/Testimonials";
import AboutUs from "./components/AboutUs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Products />
      <Solutions />
      <Science />
      <Crops />
      <Testimonials />
      <AboutUs />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
